// PrivateRoute.jsx
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const isAutenticado = localStorage.getItem('autenticado') === 'true';
  return isAutenticado ? children : <Navigate to="/" />;
}
